import { render } from "./aio-login-sub-tabs.vue?vue&type=template&id=e653d17e&scoped=true"
import script from "./aio-login-sub-tabs.vue?vue&type=script&lang=js"
export * from "./aio-login-sub-tabs.vue?vue&type=script&lang=js"

import "./aio-login-sub-tabs.vue?vue&type=style&index=0&id=e653d17e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e653d17e"]])

export default __exports__